export function getDefaultState() {
  return {
    clientIdentifier: null,
    portfolioInfo: [],
    policies: [],
    documents: [],
    directLinks: []
  }
}
